// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3fb6p","productName":"Table_productName__3PWiQ"};